/* eslint-disable */
tinymce.addI18n('es', {
  Redo: 'Rehacer',
  Undo: 'Deshacer',
  Cut: 'Cortar',
  Copy: 'Copiar',
  Paste: 'Pegar',
  'Select all': 'Seleccionar todo',
  'New document': 'Nuevo documento',
  Ok: 'Ok',
  Cancel: 'Cancelar',
  'Visual aids': 'Ayudas visuales',
  Bold: 'Negrita',
  Italic: 'It\u00e1lica',
  Underline: 'Subrayado',
  Strikethrough: 'Tachado',
  Superscript: 'Super\u00edndice',
  Subscript: 'Sub\u00edndice',
  'Clear formatting': 'Limpiar formato',
  'Align left': 'Alinear a la izquierda',
  'Align center': 'Alinear al centro',
  'Align right': 'Alinear a la derecha',
  Justify: 'Justificar',
  'Bullet list': 'Lista de vi\u00f1etas',
  'Numbered list': 'Lista numerada',
  'Decrease indent': 'Disminuir sangr\u00eda',
  'Increase indent': 'Incrementar sangr\u00eda',
  Close: 'Cerrar',
  Formats: 'Formatos',
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    'Tu navegador no soporta acceso directo al portapapeles. Por favor usa las teclas Crtl+X/C/V de tu teclado',
  Headers: 'Encabezados',
  'Header 1': 'Encabezado 1',
  'Header 2': 'Encabezado 2 ',
  'Header 3': 'Encabezado 3',
  'Header 4': 'Encabezado 4',
  'Header 5': 'Encabezado 5 ',
  'Header 6': 'Encabezado 6',
  Headings: 'Encabezados',
  'Heading 1': 'Encabezado 1',
  'Heading 2': 'Encabezado 2',
  'Heading 3': 'Encabezado 3',
  'Heading 4': 'Encabezado 4',
  'Heading 5': 'Encabezado 5',
  'Heading 6': 'Encabezado 6',
  Preformatted: 'Preformateado',
  Div: 'Capa',
  Pre: 'Pre',
  Code: 'C\u00f3digo',
  Paragraph: 'P\u00e1rrafo',
  Blockquote: 'Bloque de cita',
  Inline: 'en l\u00ednea',
  Blocks: 'Bloques',
  'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.':
    'Pegar est\u00e1 ahora en modo de texto plano. El contenido se pegar\u00e1 como texto plano hasta que desactive esta opci\u00f3n.',
  'Font Family': 'Familia de fuentes',
  'Font Sizes': 'Tama\u00f1os de fuente',
  Class: 'Clase',
  'Browse for an image': 'Exporador de imagenes',
  OR: 'O',
  'Drop an image here': 'Arrastre una imagen aqu\u00ed',
  Upload: 'Subir',
  Block: 'Bloque',
  Align: 'Alinear',
  Default: 'Por defecto',
  Circle: 'C\u00edrculo',
  Disc: 'Disco',
  Square: 'Cuadrado',
  'Lower Alpha': 'Inferior Alfa',
  'Lower Greek': 'Inferior Griega',
  'Lower Roman': 'Inferior Romana',
  'Upper Alpha': 'Superior Alfa',
  'Upper Roman': 'Superior Romana',
  Anchor: 'Ancla',
  Name: 'Nombre',
  Id: 'Id',
  'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.':
    'Deber\u00eda comenzar por una letra, seguida solo de letras, n\u00fameros, guiones, puntos, dos puntos o guiones bajos.',
  'You have unsaved changes are you sure you want to navigate away?':
    'Tiene cambios sin guardar. \u00bfEst\u00e1 seguro de que quiere salir?',
  'Restore last draft': 'Restaurar el \u00faltimo borrador',
  'Special character': 'Car\u00e1cter especial',
  'Source code': 'C\u00f3digo fuente',
  'Insert/Edit code sample': 'Insertar/editar c\u00f3digo de prueba',
  Language: 'Idioma',
  'Code sample': 'Ejemplo de c\u00f3digo',
  Color: 'Color',
  R: 'R',
  G: 'V',
  B: 'A',
  'Left to right': 'De izquierda a derecha',
  'Right to left': 'De derecha a izquierda',
  Emoticons: 'Emoticonos',
  'Document properties': 'Propiedades del documento',
  Title: 'T\u00edtulo',
  Keywords: 'Palabras clave',
  Description: 'Descripci\u00f3n',
  Robots: 'Robots',
  Author: 'Autor',
  Encoding: 'Codificaci\u00f3n',
  Fullscreen: 'Pantalla completa',
  Action: 'Acci\u00f3n',
  Shortcut: 'Atajo',
  Help: 'Ayuda',
  Address: 'Direcci\u00f3n',
  'Focus to menubar': 'Enfocar la barra del men\u00fa',
  'Focus to toolbar': 'Enfocar la barra de herramientas',
  'Focus to element path': 'Enfocar la ruta del elemento',
  'Focus to contextual toolbar': 'Enfocar la barra de herramientas contextual',
  'Insert link (if link plugin activated)':
    'Insertar enlace (si el complemento de enlace est\u00e1 activado)',
  'Save (if save plugin activated)': 'Guardar (si el componente de salvar est\u00e1 activado)',
  'Find (if searchreplace plugin activated)':
    'Buscar (si el complemento buscar-remplazar est\u00e1 activado)',
  'Plugins installed ({0}):': 'Plugins instalados ({0}):',
  'Premium plugins:': 'Complementos premium:',
  'Learn more...': 'Aprende m\u00e1s...',
  'You are using {0}': 'Estas usando {0}',
  Plugins: 'Complementos',
  'Handy Shortcuts': 'Accesos directos',
  'Horizontal line': 'L\u00ednea horizontal',
  'Insert/edit image': 'Insertar/editar imagen',
  'Image description': 'Descripci\u00f3n de la imagen',
  Source: 'Enlace',
  Dimensions: 'Dimensiones',
  'Constrain proportions': 'Restringir proporciones',
  General: 'General',
  Advanced: 'Avanzado',
  Style: 'Estilo',
  'Vertical space': 'Espacio vertical',
  'Horizontal space': 'Espacio horizontal',
  Border: 'Borde',
  'Insert image': 'Insertar imagen',
  Image: 'Imagen',
  'Image list': 'Lista de im\u00e1genes',
  'Rotate counterclockwise': 'Girar a la izquierda',
  'Rotate clockwise': 'Girar a la derecha',
  'Flip vertically': 'Invertir verticalmente',
  'Flip horizontally': 'Invertir horizontalmente',
  'Edit image': 'Editar imagen',
  'Image options': 'Opciones de imagen',
  'Zoom in': 'Acercar',
  'Zoom out': 'Alejar',
  Crop: 'Recortar',
  Resize: 'Redimensionar',
  Orientation: 'Orientaci\u00f3n',
  Brightness: 'Brillo',
  Sharpen: 'Forma',
  Contrast: 'Contraste',
  'Color levels': 'Niveles de color',
  Gamma: 'Gamma',
  Invert: 'Invertir',
  Apply: 'Aplicar',
  Back: 'Atr\u00e1s',
  'Insert date/time': 'Insertar fecha/hora',
  'Date/time': 'Fecha/hora',
  'Insert link': 'Insertar enlace',
  'Insert/edit link': 'Insertar/editar enlace',
  'Text to display': 'Texto para mostrar',
  Url: 'URL',
  Target: 'Destino',
  None: 'Ninguno',
  'New window': 'Nueva ventana',
  'Remove link': 'Quitar enlace',
  Anchors: 'Anclas',
  Link: 'Enlace',
  'Paste or type a link': 'Pega o introduce un enlace',
  'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?':
    'El enlace que has introducido no parece ser una direcci\u00f3n de correo electr\u00f3nico. Quieres a\u00f1adir el prefijo necesario mailto: ?',
  'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?':
    'El enlace que has introducido no parece ser una enlace externo. Quieres a\u00f1adir el prefijo necesario http:// ?',
  'Link list': 'Lista de enlaces',
  'Insert video': 'Insertar video',
  'Insert/edit video': 'Insertar/editar video',
  'Insert/edit media': 'Insertar/editar medio',
  'Alternative source': 'Enlace alternativo',
  Poster: 'Miniatura',
  'Paste your embed code below:': 'Pega tu c\u00f3digo embebido debajo',
  Embed: 'Incrustado',
  Media: 'Media',
  'Nonbreaking space': 'Espacio fijo',
  'Page break': 'Salto de p\u00e1gina',
  'Paste as text': 'Pegar como texto',
  Preview: 'Previsualizar',
  Print: 'Imprimir',
  Save: 'Guardar',
  Find: 'Buscar',
  'Replace with': 'Reemplazar con',
  Replace: 'Reemplazar',
  'Replace all': 'Reemplazar todo',
  Prev: 'Anterior',
  Next: 'Siguiente',
  'Find and replace': 'Buscar y reemplazar',
  'Could not find the specified string.': 'No se encuentra la cadena de texto especificada',
  'Match case': 'Coincidencia exacta',
  'Whole words': 'Palabras completas',
  Spellcheck: 'Corrector ortogr\u00e1fico',
  Ignore: 'Ignorar',
  'Ignore all': 'Ignorar todos',
  Finish: 'Finalizar',
  'Add to Dictionary': 'A\u00f1adir al Diccionario',
  'Insert table': 'Insertar tabla',
  'Table properties': 'Propiedades de la tabla',
  'Delete table': 'Eliminar tabla',
  Cell: 'Celda',
  Row: 'Fila',
  Column: 'Columna',
  'Cell properties': 'Propiedades de la celda',
  'Merge cells': 'Combinar celdas',
  'Split cell': 'Dividir celdas',
  'Insert row before': 'Insertar fila antes',
  'Insert row after': 'Insertar fila despu\u00e9s ',
  'Delete row': 'Eliminar fila',
  'Row properties': 'Propiedades de la fila',
  'Cut row': 'Cortar fila',
  'Copy row': 'Copiar fila',
  'Paste row before': 'Pegar la fila antes',
  'Paste row after': 'Pegar la fila despu\u00e9s',
  'Insert column before': 'Insertar columna antes',
  'Insert column after': 'Insertar columna despu\u00e9s',
  'Delete column': 'Eliminar columna',
  Cols: 'Columnas',
  Rows: 'Filas',
  Width: 'Ancho',
  Height: 'Alto',
  'Cell spacing': 'Espacio entre celdas',
  'Cell padding': 'Relleno de celda',
  Caption: 'Subt\u00edtulo',
  Left: 'Izquierda',
  Center: 'Centrado',
  Right: 'Derecha',
  'Cell type': 'Tipo de celda',
  Scope: '\u00c1mbito',
  Alignment: 'Alineaci\u00f3n',
  'H Align': 'Alineamiento Horizontal',
  'V Align': 'Alineamiento Vertical',
  Top: 'Arriba',
  Middle: 'Centro',
  Bottom: 'Abajo',
  'Header cell': 'Celda de la cebecera',
  'Row group': 'Grupo de filas',
  'Column group': 'Grupo de columnas',
  'Row type': 'Tipo de fila',
  Header: 'Cabecera',
  Body: 'Cuerpo',
  Footer: 'Pie de p\u00e1gina',
  'Border color': 'Color del borde',
  'Insert template': 'Insertar plantilla',
  Templates: 'Plantillas',
  Template: 'Plantilla',
  'Text color': 'Color del texto',
  'Background color': 'Color de fondo',
  'Custom...': 'Personalizar...',
  'Custom color': 'Color personalizado',
  'No color': 'Sin color',
  'Table of Contents': 'Tabla de contenidos',
  'Show blocks': 'Mostrar bloques',
  'Show invisible characters': 'Mostrar caracteres invisibles',
  'Words: {0}': 'Palabras: {0}',
  '{0} words': '{0} palabras',
  File: 'Archivo',
  Edit: 'Editar',
  Insert: 'Insertar',
  View: 'Ver',
  Format: 'Formato',
  Table: 'Tabla',
  Tools: 'Herramientas',
  'Powered by {0}': 'Desarrollado por {0}',
  'Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help':
    '\u00c1rea de texto enriquecido. Pulse ALT-F9 para el menu. Pulse ALT-F10 para la barra de herramientas. Pulse ALT-0 para ayuda',
});
